import {JobApplicationInOverview} from "@/data/entities/jobApplication";
import {ReactNode} from "react";

export enum JobApplicationsFilterStatus {
    ALL = "ALL",
    OPEN = "OPEN",
    IN_PROGRESS = "IN_PROGRESS",
    CLOSED = "CLOSED",
}

export type JobApplicationInDataTable = JobApplicationInOverview & {
    options: ReactNode,
};

export const jobApplicationsDataTableBaseUrl = (
    dashboardLocation: number,
    status: JobApplicationsFilterStatus,
): string => {
    const dataUrl = new URL(`${process.env.BACKEND_API_BASE_URL}/careers/job-applications/${dashboardLocation}/all`);

    if (status !== JobApplicationsFilterStatus.ALL)
        dataUrl.searchParams.set("status", status);

    return dataUrl.toString()
};
